import { render, staticRenderFns } from "./Ambassador.vue?vue&type=template&id=15908cb2&scoped=true&"
import script from "./Ambassador.vue?vue&type=script&lang=js&"
export * from "./Ambassador.vue?vue&type=script&lang=js&"
import style0 from "./Ambassador.vue?vue&type=style&index=0&id=15908cb2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15908cb2",
  null
  
)

export default component.exports